import { BACKEND_URI } from '@/config/env'
import axios from 'axios'
import { logout } from '../api/axiosAuthorization'
import { authDebug } from './authDebug'

// 별도 axios 인스턴스 (interceptor 없음 - 무한루프 방지)
const expirationClient = axios.create({
  baseURL: BACKEND_URI,
  withCredentials: true,
})

// 만료 체크 스킵할 URL 목록
const SKIP_URLS = ['/auth/login', '/auth/logout', '/auth/login-remaining-second']

// 버퍼 시간 (60초 미만이면 만료로 처리)
const BUFFER_SECONDS = 60

// 쓰로틀링 (30초에 한 번만 체크)
let lastCheckTime = 0
const THROTTLE_MS = 30000

export const checkTokenExpiration = async (): Promise<boolean> => {
  try {
    const response = await expirationClient.get<number>('/auth/login-remaining-second')
    const data = response.data
    // 백엔드 응답이 { success, data } 형태일 경우 처리
    const remaining =
      typeof data === 'object' && data !== null && 'data' in data
        ? (data as unknown as { data: number }).data
        : (data as number)
    const isValid = remaining > BUFFER_SECONDS
    authDebug.tokenCheck(remaining, isValid)
    return isValid
  } catch (error) {
    const status = axios.isAxiosError(error) ? error.response?.status : undefined
    if (status === 401 || status === 400) {
      // /auth/login-remaining-second 전용 클라이언트이므로 이 엔드포인트에서
      // 400이 오면 쿠키 미존재/만료로 판단. axiosRequest.ts와 달리 code 필드
      // 체크가 불필요 — 이 엔드포인트는 유효성 검증 입력이 없어 일반 400이 발생하지 않음.
      authDebug.tokenCheck(-1, false)
      return false
    }
    // 네트워크 에러 등 인프라 이슈 → 원래 요청 진행 (기존 방어 로직 유지)
    console.warn('[Auth Debug] Token expiration check failed:', error)
    return true
  }
}

export const shouldSkipCheck = (url?: string): boolean => {
  if (!url) return true
  return SKIP_URLS.some((skip) => url.includes(skip))
}

export const shouldThrottle = (): boolean => {
  const now = Date.now()
  if (now - lastCheckTime < THROTTLE_MS) return true
  lastCheckTime = now
  return false
}

export const handleExpiredToken = (): void => {
  logout()
}
